import { render, staticRenderFns } from "./BaseTabs.vue?vue&type=template&id=0310f4ad&scoped=true"
import script from "./BaseTabs.vue?vue&type=script&lang=js"
export * from "./BaseTabs.vue?vue&type=script&lang=js"
import style0 from "./BaseTabs.vue?vue&type=style&index=0&id=0310f4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0310f4ad",
  null
  
)

export default component.exports